interface SocialButtonsProps {
  onSelect: (provider: 'google' | 'apple') => void;
  disabled?: boolean;
}

function GoogleLogo() {
  return (
    <svg viewBox="0 0 24 24" className="h-[18px] w-[18px]" aria-hidden="true">
      <path fill="#4285F4" d="M23.5 12.27c0-.85-.08-1.67-.22-2.45H12v4.64h6.45a5.52 5.52 0 0 1-2.39 3.62v3h3.87c2.26-2.08 3.57-5.15 3.57-8.81Z" />
      <path fill="#34A853" d="M12 24c3.24 0 5.96-1.07 7.94-2.92l-3.87-3c-1.07.72-2.45 1.15-4.07 1.15-3.13 0-5.78-2.11-6.73-4.95H1.27v3.1A12 12 0 0 0 12 24Z" />
      <path fill="#FBBC05" d="M5.27 14.28a7.2 7.2 0 0 1 0-4.56v-3.1H1.27a12 12 0 0 0 0 10.76l4-3.1Z" />
      <path fill="#EA4335" d="M12 4.77c1.76 0 3.34.61 4.59 1.8l3.43-3.43A11.5 11.5 0 0 0 12 0 12 12 0 0 0 1.27 6.62l4 3.1C6.22 6.88 8.87 4.77 12 4.77Z" />
    </svg>
  );
}

function AppleLogo() {
  return (
    <svg viewBox="0 0 24 24" className="h-[18px] w-[18px]" fill="currentColor" aria-hidden="true">
      <path d="M16.37 1.43c0 1.14-.42 2.2-1.25 3.04-.86.87-1.91 1.37-3.05 1.28-.14-1.1.43-2.27 1.22-3.07.86-.86 2.1-1.43 3.08-1.25ZM20.5 17.1c-.55 1.27-.82 1.84-1.53 2.96-.99 1.56-2.39 3.5-4.12 3.51-1.54.02-1.94-1-4.03-.99-2.09.01-2.53 1.01-4.07.99-1.73-.02-3.05-1.77-4.04-3.33C-.07 15.9-.36 10.9 1.43 8.19c1.27-1.92 3.27-3.04 5.15-3.04 1.92 0 3.12 1.05 4.71 1.05 1.54 0 2.48-1.05 4.7-1.05 1.68 0 3.46.91 4.73 2.49-4.15 2.28-3.48 8.2-.22 9.46Z" />
    </svg>
  );
}

// Botões de login social. No modo apresentação simulam o retorno do provedor.
export function SocialButtons({ onSelect, disabled }: SocialButtonsProps) {
  const base =
    'flex w-full items-center justify-center gap-2.5 rounded-lg border px-4 py-2.5 text-sm font-medium transition-all duration-200 active:scale-[0.98] disabled:opacity-60';

  return (
    <div className="grid gap-3 sm:grid-cols-2">
      <button
        type="button"
        disabled={disabled}
        onClick={() => onSelect('google')}
        className={`${base} border-border bg-surface text-ink hover:border-ink/30 hover:shadow-card`}
      >
        <GoogleLogo />
        Google
      </button>
      <button
        type="button"
        disabled={disabled}
        onClick={() => onSelect('apple')}
        className={`${base} border-border bg-surface text-ink hover:border-ink/30 hover:shadow-card`}
      >
        <AppleLogo />
        Apple
      </button>
    </div>
  );
}

export function OrDivider({ label = 'ou continue com' }: { label?: string }) {
  return (
    <div className="flex items-center gap-3 text-xs text-ink-secondary">
      <span className="h-px flex-1 bg-border/70" />
      {label}
      <span className="h-px flex-1 bg-border/70" />
    </div>
  );
}
